<template>
    <div>
        <div class="OperationBar">
            <el-button type="primary" plain @click="handleClickAddNew">添加产品</el-button>
            <el-button type="info" plain @click="handleClickDelete">删除</el-button>
        </div>
        <div class="SearchBar">
            <el-row>
                <el-col :span="3" class="subTitle">
                    大类名称：
                </el-col>
                <el-col :span="5" class="searchArea">
                    <el-select v-model="productListParam.ProductDetail_mtype" @change="handleSubType" placeholder="请选择">
                        <el-option :value=0 :key=0 label="请选择"></el-option>
                        <el-option
                        v-for="item in searchArea.mType"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                </el-col>
                <el-col :span="3" class="subTitle">
                    小类名称：
                </el-col>
                <el-col :span="5" class="searchArea">
                    <el-select v-model="productListParam.ProductDetail_stype" placeholder="请选择">
                        <el-option
                        v-for="item in  searchArea.sType"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                </el-col>
                <!-- <el-col :span="3" class="subTitle">
                    产品名称：
                </el-col>
                <el-col :span="5" class="searchArea">
                    <el-input v-model="productListParam.ProductDetail_name" placeholder="请选择" clearable />
                </el-col> -->
                <el-col :span="3" class="subTitle">
                    产品状态：
                </el-col>
                <el-col :span="5" class="searchArea">
                    <el-select v-model="productListParam.ProductDetail_status" placeholder="请选择">
                        <el-option
                        v-for="item in searchArea.status"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                </el-col>
                <el-col :span="3" class="subTitle">
                    语言：
                </el-col>
                <el-col :span="5" class="searchArea">
                    <el-select v-model="productListParam.Lang" placeholder="请选择">
                        <el-option
                        v-for="item in searchArea.Lang"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="3" class="subTitle">
                </el-col>
                <el-col :span="5" class="searchArea">
                    <el-button type="primary" :icon="iconArr.pfSearch" @click="clickSearchProductList">Search</el-button>
                </el-col>
            </el-row>
        </div>
        <div style="width:100%;">
            <el-table ref="productList" :data="tableData" style="width: 100%;">
                <el-table-column fixed type="selection" width="55" />
                <el-table-column fixed prop="id" label="产品ID" />
                <el-table-column prop="productDetail_mtype" label="大类名称" />
                <el-table-column prop="productDetail_stype" label="小类名称" />
                <!-- <el-table-column prop="productDetail_name" label="产品名称" /> -->
                <el-table-column prop="attchs" label="产品小图" width="330">
                    <template #default="scope" >
                        <div style="display: inline-flex; ">
                            <el-image v-for="(item,index ) in scope.row.attchs" style="width: 100px; height: 100px; border:1px solid #ccc; margin-right:5px;" :src="this.tempPicUrl.filter(e=> e.id === scope.row.attchs[index])[0]?.url"  :key="item" /></div>
                    </template>
                </el-table-column >
                <el-table-column prop="productDetail_status" label="产品状态"  style="width: 100%;"/>
                <el-table-column fixed="right" label="操作">
                    <template #default="scope">
                        <el-button link type="primary" size="small" @click.prevent="modifyProductRow( scope.row )">编辑</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                small
                background
                layout="prev, pager, next"
                :total="this.totalRows"
                :page-count="this.totalPage"
                @current-change="hanldeCurrentPage"
                class="mt-4" style="margin: 7px 15px;">
            </el-pagination>
        </div>
        <addProductDialog :isAddProductShow="isAddProductShow" :timekey="timerAdd" @hanldeCurrentPage="hanldeCurrentPage"></addProductDialog>
        <modifyProductDialog :isModifyProductShow="isModifyProductShow" :timekey="timerModify" :currentProductDetial="currentRow" @hanldeCurrentPage="hanldeCurrentPage"></modifyProductDialog>
    </div>
</template>

<script>
import { markRaw } from "vue"
import addProductDialog from './child/addProductDialog'
import modifyProductDialog from './child/modifyProductDialog'
import { Search } from '@element-plus/icons-vue'
import api from '@/api/api';
import cxf from '@/utils/GeneralFn';
    export default {
        name: "productManage",
        components: {
            'addProductDialog':addProductDialog,
            'modifyProductDialog':modifyProductDialog
        },
        data() {
            return {
                timerAdd:0,
                timerModify:0,
                iconArr:{
                    "pfSearch":markRaw(Search)
                },
                tableData :[],
                currentRow: [],
                searchArea:{
                    mType:cxf.getMainType(),
                    sType:[],
                    status:cxf.getProductStatus(),
                    Lang:cxf.getProductLang()
                },
                productListParam : {
                    PageNo:1,
                    PageSize:10,
                    SortOrder:'desc',
                    SearchDate:"",
                    SearchBeginTime:"",
                    SearchEndTime:"",
                    ProductDetail_mtype:"",
                    ProductDetail_stype:"",
                    ProductDetail_name:"",
                    ProductDetail_status:"",
                    Lang:"",
                    SearchParameters: []
                    
                },
                totalPage:1,
                totalRows:1,
                isAddProductShow:false,
                isModifyProductShow:false,
                tempPicUrl:[]
            }
        },
        created(){
        },
        mounted(){
            this.getProductList()
        },
        methods:{
            async getProductList () {
                this.productListParam.SearchParameters = [];
                for ( let item in this.productListParam ) {
                    if ( item === "ProductDetail_mtype" && this.productListParam["ProductDetail_mtype"] !== "" && this.productListParam["ProductDetail_mtype"] !== 0 ) {
                        this.productListParam.SearchParameters.push({"Field":"ProductDetail_mtype","Op":"0","Value":this.productListParam["ProductDetail_mtype"]});
                    }
                    if ( item === "ProductDetail_stype" && this.productListParam["ProductDetail_stype"] !== "" && this.productListParam["ProductDetail_stype"] !== 0 ) {
                        this.productListParam.SearchParameters.push({"Field":"ProductDetail_sType","Op":"0","Value":this.productListParam["ProductDetail_stype"]});
                    }
                    if ( item === "ProductDetail_name" && this.productListParam["ProductDetail_name"] !== "" ) {
                        this.productListParam.SearchParameters.push({"Field":"ProductDetail_name","Op":"8","Value":this.productListParam["ProductDetail_name"]});
                    }
                    if ( item === "ProductDetail_status" && this.productListParam["ProductDetail_status"] !== "" && this.productListParam["ProductDetail_status"] !== 0 ) {
                        this.productListParam.SearchParameters.push({"Field":"ProductDetail_status","Op":"0","Value":this.productListParam["ProductDetail_status"]});
                    }
                    if ( item === "SearchBeginTime" && this.productListParam["SearchBeginTime"] !== "" ) {
                        this.productListParam.SearchParameters.push({"Field":"updatetime","Op":"3","Value":this.productListParam["SearchBeginTime"]});
                    }
                    if ( item === "SearchEndTime" && this.productListParam["SearchEndTime"] !== "" ) {
                        this.productListParam.SearchParameters.push({"Field":"updatetime","Op":"5","Value":this.productListParam["SearchEndTime"]});
                    }
                    if ( item === "Lang"  && this.productListParam["Lang"] !== "" ) {
                        this.productListParam.SearchParameters.push({"Field":"Lang","Op":"0","Value":this.productListParam["Lang"]});
                    }
                }

                const _resList = await api.postProductList( this.productListParam );
                if ( _resList.data.success ) {
                    const _tableList = _resList.data.data;
                    this.totalPage = _tableList.totalPage;
                   
                    this.totalRows = _tableList.totalRows;
                    this.tableData = _tableList.rows;
                    this.tableData.forEach( async e => {
                        let tempmTypeValue = e.productDetail_mtype;
                        let tempsTypeValue = e.productDetail_stype;
                        e.productDetail_mtype = cxf.getMainType( tempmTypeValue, true );
                        e.productDetail_stype = cxf.getSubType( tempmTypeValue, true, tempsTypeValue );
                        e.productDetail_status = cxf.getProductStatus( e.productDetail_status, true );
                        for ( let d in e.attchs) {
                           await this.getImage(e.attchs[d]);
                        }
                    })
                } else {
                    this.$message({
                        message: _resList.data.message,
                        type: 'warning'
                    });
                }
            },
            hanldeCurrentPage( pageNum ){
                this.productListParam.PageNo = pageNum || 1;
                this.getProductList();
            },
            handleClickAddNew () {
                this.timerAdd = new Date().getTime();
                this.isAddProductShow = true;
            },
            handleClickDelete() {
                const _deleteFromData = new FormData();
                const _selectedIds = this.$refs.productList.getSelectionRows().map(e => e.id);
                for (let i = 0; i < _selectedIds.length; i++) {
                    _deleteFromData.append( "inputs",_selectedIds[i]);
                }
                _deleteFromData.append("apiType", "fromData");
                api.postDeleteProduct( _deleteFromData ).then( res => {
                    console.log(res);
                    this.hanldeCurrentPage( 1 );
                }).catch( err => {
                    console.log(err);
                });
            },
            async getImage( id ) {
                if (id) {
                    let _tempRes = await api.getSysFileInfoPreview({id: id});
                    if ( _tempRes.status === 200 ) {
                        return this.tempPicUrl.push({ id:id,url:window.URL.createObjectURL(new Blob([_tempRes.data]))})
                    } else {
                        return '--';
                    }
                   
                } else {
                    return "无图片"
                }
                
            },
            handleSubType( mid ) {
                this.searchArea.sType = cxf.getSubType( mid+'' );
            },
            changeSearchDate( n ){
                this.productListParam.SearchBeginTime = cxf.timeChange(n[0]);
                this.productListParam.SearchEndTime = cxf.timeChange(n[1]);
            },
            clickSearchProductList () {
                this.getProductList();
            },
            modifyProductRow ( row ) {
                this.currentRow = row;
                this.timerModify = new Date().getTime();
                this.isModifyProductShow = true;
            }
        },
        watch:{
            isAddProductShow( nv ){
                this.isAddProductShow = nv;
            }
        }
    }
</script>


<style scoped>
</style>